import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("ErrorBoundary:", error, info); }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-950 p-6">
          <div className="max-w-md text-center bg-slate-900 border border-red-500/40 rounded-md p-6">
            <div className="text-red-400 text-2xl font-bold mb-2">⚠ Errore di caricamento</div>
            <p className="text-sm text-slate-300 mb-3">Qualcosa è andato storto nel pannello. Ricarica la pagina o controlla i dettagli tecnici.</p>
            <pre className="text-[10px] text-slate-500 font-mono bg-slate-950 p-2 rounded overflow-auto max-h-40">{String(this.state.error?.message || this.state.error)}</pre>
            <button onClick={() => window.location.reload()} className="mt-4 px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-md text-white text-sm">Ricarica</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
